<template>
  <div class="migrate-wrapper px-1 py-2">
    <div class="migrate-shell">
      <migrate-notice />
    </div>

    <p class="mg-signin">
      Đã có tài khoản FastProxy?
      <b-link :to="{ name: 'login' }">Đăng nhập</b-link>
    </p>
  </div>
</template>

<script>
import { BLink } from 'bootstrap-vue'
import MigrateNotice from '@/components/MigrateNotice.vue'

export default {
  components: {
    BLink,
    MigrateNotice,
  },
}
</script>

<style lang="scss" scoped>
.migrate-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.migrate-shell {
  width: 100%;
  max-width: 1080px;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 4px 24px rgba(34, 41, 47, 0.1);
}

.mg-signin {
  margin: 1.25rem 0 0;
  color: #6b7280;
  font-size: 0.95rem;
}
</style>
